// Mirrors the server's EmailDomain.TryGet so the share UI can warn before the API rejects.
export function getEmailDomain(value: string | null | undefined): string | null {
  if (!value) return null
  const parts = value.trim().split('@')
  if (parts.length !== 2 || parts[0].length === 0 || parts[1].length === 0) return null
  return parts[1].toLowerCase()
}
